import { ConnectAction, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { Observable } from 'rxjs';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { ViewData } from '../../model/view.data';
import { Model } from '../../model/model';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';

/**
 * VO free data
 */
@entity('wizeoo.allkeyme.core.message.ConnectAction', 'BU')
export class ConnectVO implements IVo {
  private _source: ConnectAction; // connecteur source

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }


  constructor(model: Model, pSource?: ConnectAction) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new ConnectAction();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau

    }
  }

  public set source(src: ConnectAction) {
    this._source = src;
  }

  public get source(): ConnectAction {
    return this._source;
  }

  public get id(): number {
    return this._source.id;
  }

  public set id(id: number) {
    this._source.id = id;
  }

  public get uid(): string {
    return this._source.uid;
  }
  public set uid(uid: string) {
    this._source.uid = uid;
  }

  /** Domaine */
  public set domain(domain: string) {
    this._source.domain = domain;
  }
  @field('string')
  public get domain(): string {
    return this._source.domain;
  }

  /** BU */
  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }
  @field('string')
  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  /** Code */
  @field('string')
  public set code(code: string) {
    this._source.code = code;
  }
  public get code(): string {
    return this._source.code;
  }

  /** Code du process */
  @field('string')
  public set processCode(code: string) {
    this._source.processCode = code;
  }
  public get processCode(): string {
    return this._source.processCode;
  }

  /** Mode sync / async */
  @field('string')
  public set processMode(processMode: string) {
    this._source.processMode = processMode;
  }
  public get processMode(): string {
    return this._source.processMode;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this._source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this._source.maintenanceFlag = value;
  }

  public get operation(): string {
    return this._source.operation;
  }
  public set operation(value: string) {
    this._source.operation = value;
  }

  @field('boolean')
  public get deprecated(): boolean {
    return this._source.deprecated;
  }
  public set deprecated(value: boolean) {
    this._source.deprecated = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this._source.description = value;
  }
  public get description(): TranslatedEmb {
    return this._source.description;
  }

  @field('string')
  public get icon(): string {
    return this._source.icon;
  }

  public set icon(pValue: string) {
    this._source.icon = pValue;
  }

  /** cible FD / Baseline */
  public set scope(value: string) {
    this._source.scope = value;
  }
  @field('string')
  public get scope(): string {
    return this._source.scope;
  }

  /** paramètres de l'action */
  public set parameters(value: any) {
    this._source.parameters = value;
  }
  @field('string')
  public get parameters(): any {
    return this._source.parameters;
  }

  /** action en retour */
  public set resultAction(value: string) {
    this._source.resultAction = value;
  }
  @field('string')
  public get resultAction(): string {
    return this._source.resultAction;
  }


  /** titre warning */
  @field('TranslatedEmb')
  public set warnTitle(label: TranslatedEmb) {
    this._source.warnTitle = label;
  }

  public get warnTitle(): TranslatedEmb {
    return this._source.warnTitle;
  }

  /** détail warning */
  @field('TranslatedEmb')
  public set warnDetail(label: TranslatedEmb) {
    this._source.warnDetail = label;
  }

  public get warnDetail(): TranslatedEmb {
    return this._source.warnDetail;
  }

  /** resultSuccess */
  @field('TranslatedEmb')
  public set resultSuccess(label: TranslatedEmb) {
    this._source.resultSuccess = label;
  }

  public get resultSuccess(): TranslatedEmb {
    return this._source.resultSuccess;
  }

  /** resultError */
  @field('TranslatedEmb')
  public set resultError(label: TranslatedEmb) {
    this._source.resultError = label;
  }

  public get resultError(): TranslatedEmb {
    return this._source.resultError;
  }

  @field('boolean')
  public get useWarning(): boolean {
    return this._source.useWarning;
  }
  public set useWarning(value: boolean) {
    this._source.useWarning = value;
  }


  /* ################################################
                    Accesseurs composites
  ################################################ */

  public toDie: boolean = false;

  /** Le free data est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }

  /** retourne l'icone si existe, sinon le média par défaut */
  public get iconOrDie(): Observable<string> {
    return AttachmentService.getInstance().iconOrDie(this.icon, this.domain, this.businessUnitCode, ViewData.wildcardMainVision);
  }

  /* ################################################
              gestion de la traduction
  ################################################ */

  /**
   * Return translated label
   * @return string
   */
  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.processCode);
  }

  /**
   * Return translated label
   * @return string
   */
  get trsDescription(): string {
    return this.model.localeEngine.translate(this.description);
  }

  get trsWarnTitle(): string {
    return this.model.localeEngine.translate(this.warnTitle);
  }
  get trsWarnDetail(): string {
    return this.model.localeEngine.translate(this.warnDetail);
  }
  get trsResultError(): string {
    return this.model.localeEngine.translate(this.resultError);
  }
  get trsResultSuccess(): string {
    return this.model.localeEngine.translate(this.resultSuccess);
  }


  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** desc traductible */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /** desc traductible */
  private _warnTitleVO: TranslatableLabelVO;
  public get warnTitleVO(): TranslatableLabelVO {
    if (!this._warnTitleVO) {
      this._warnTitleVO = this.model.localeEngine.newTranslatableVO(this, 'warnTitle');
    }
    return this._warnTitleVO;
  }

  /** desc traductible */
  private _warnDetailVO: TranslatableLabelVO;
  public get warnDetailVO(): TranslatableLabelVO {
    if (!this._warnDetailVO) {
      this._warnDetailVO = this.model.localeEngine.newTranslatableVO(this, 'warnDetail');
    }
    return this._warnDetailVO;
  }


      /** desc traductible */
  private _resultErrorVO: TranslatableLabelVO;
  public get resultErrorVO(): TranslatableLabelVO {
    if (!this._resultErrorVO) {
      this._resultErrorVO = this.model.localeEngine.newTranslatableVO(this, 'resultError');
    }
    return this._resultErrorVO;
  }


  /** desc traductible */
  private _resultSuccessVO: TranslatableLabelVO;
  public get resultSuccessVO(): TranslatableLabelVO {
    if (!this._resultSuccessVO) {
      this._resultSuccessVO = this.model.localeEngine.newTranslatableVO(this, 'resultSuccess');
    }
    return this._resultSuccessVO;
  }

  /* ################################################
              gestion des paramètres (json)
  ################################################ */

  public get uniqueKey(): string {
    return [this.domain, this.businessUnitCode, this.code].join(ViewData.KEY_SEPARATOR);
  }

  /**
   * paramètres en mode string
   * @return string
   */
  get trsParameters(): string {
    return this.parameters ? JSON.stringify(this.parameters) : null;
  }

  /**
   * paramètres en mode string
   * @return string
   */
  set trsParameters(value: string) {
    if(!!value) {
      try {
        this.parameters = JSON.parse(value);
      } catch(e: any) {
        console.log('oups', e);
      }
    } else {
      this.parameters = null;
    }
    
  }

}
